const map: Record<string, any> = {};

export function setMarkdownOptions(editorId: string, options: any) {
  map[editorId] = options;
}

export function getMarkdownOptions(editorId: string) {
  const options = map[editorId];
  return options;
}

export function clearMarkdownOptions(editorId: string) {
  map[editorId] = null;
  // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
  delete map[editorId];
}
